export const landingCopy = {
  hero: {
    brand: '[FLOWQA]',
    headline: 'Test Results Tooling For Modern Teams.',
    subheading: 'Cut through the noise. Save time. Get insights.',
    primaryCta: 'Sign Up For Free',
    secondaryCta: 'Example Project',
  },
  testingChanged: {
    sectionTitles: {
      awareness: 'How Much Do You Really Know About Your Tests?',
      struggles: 'Common Issues We See Over And Over',
      conclusion: 'The Results Data Already Exists - Why Not Use It?',
    },
    awarenessParagraphs: [
      "Tests are a non-negotiable part of software development, but testing often only gives a one-time snapshot into software quality whether it's through manual regression runs or automated pipeline executions.",
      'Code output is up, tests are auto-generated, but our understanding of quality struggles to keep up.',
    ],
    bullets: [
      'Knowing what tests are run for your features, and where (and when)',
      'Stretched or limited QA capacity, feeling the pressure tracking multiple projects at once',
      'Outdated spreadsheets with custom formulae and ad-hoc reports that take hours to maintain',
      "Identifying the patterns that's causing their build pipelines to fail (it's always that one test)",
      'Not having the clear data to back up quality concerns, or to highlight success over time',
    ],
  },
  flowSteps: [
    {
      title: 'Run Your Tests',
      bullets: [
        'Run your tests as normal',
        'Record the results',
        '.xlsx, .csv, .xml, .json - your choice',
      ],
    },
    {
      title: 'Upload The Results',
      bullets: [
        'Upload the data to FlowQA',
        'Manually, via terminal, or during your pipeline',
        "We'll parse and aggregate the important bits",
      ],
    },
    {
      title: 'Gain Insights',
      bullets: [
        'Track test metrics across projects in one place',
        'Search, filter, and find insights about your suites, tests, and pipelines',
      ],
    },
  ],
  qualityHighlights: {
    heading: 'Track Quality Over Time',
    intro:
      'Trace status and metric trends and changes, with customisable thresholds to keep your team on-track.',
  },
  featurePanels: [
    {
      title: 'For Testers & QAs',
      items: [
        'Understand suite and test health over time',
        'One place for all your results, of any format',
        'No more cumbersome spreadsheets or reports',
        'More time back for the important things - improving quality, not summarising results',
      ],
    },
    {
      title: 'For Developers',
      items: [
        "Find out fast what's slowing down (or breaking) your pipeline builds",
        'Locate the source of instability immediately',
        'Track failure details without trawling build logs',
        'Works with your existing testing frameworks',
      ],
    },
    {
      title: 'For Leads & Managers',
      items: [
        'Track quality over multiple teams and projects',
        'Release with confidence based on data, not vibes',
        'Real-time updates on testing - make informed decisions fast',
        'Customisable reports to share with stakeholders',
      ],
    },
  ],
  executionTables: {
    heading: 'Drill Down Into The Details',
    intro:
      "Easily track every suite, test and pipeline's latest stats, and historical performance.",
  },
} as const;
